import {FormSubmitCallback, Inputs} from "./types";
import {createApplicationFormData} from "./Helper";

export const createForm = ( form: HTMLFormElement, inputs: Inputs, submitCallback: FormSubmitCallback ) => {
    return {
        el: form,
        inputs: inputs,

        init(): void {
            this._bindClass();
            this._bindEvents();
        },

        _bindClass(): void {
            this.submit = this.submit.bind(this);
        },

        _bindEvents(): void {
            this.el.addEventListener( 'submit', this.submit );
        },

        printError( message: string ): void {
            console.error( message );
        },

        printSuccess( message: string ): void {
            console.log( message );
        },

        reset(): void {
            Object.values(this.inputs).forEach((input) => {
                input?.reset();
            });
        },

        async submit(event: Event): Promise<void> {
            event.preventDefault();
            const body = createApplicationFormData( this.el );
            submitCallback( this, body );
        },

        validate(): boolean {
            let isValid = true;

            Object.values(this.inputs).forEach((input) => {
                if (!input) {
                    return;
                }

                input.resetErrors();

                const inputIsValid = input.validate();

                if ( ! inputIsValid ) {
                    input.markAsInvalid();
                    isValid = false;
                } else {
                    input.markAsValid();
                }

                input.printErrors();
            });

            return isValid;
        }
    };
}
